namespace AgerLMS.LMS {
    export interface FaqRow {
        Id?: number;
        Question?: string;
        Answer?: string;
        EntityType?: EntityTypes;
        EntityId?: number;
        DisplayOrder?: number;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
        IsActive?: number;
        InsertUserDisplayName?: string;
    }

    export namespace FaqRow {
        export const idProperty = 'Id';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'Question';
        export const localTextPrefix = 'LMS.Faq';
        export const deletePermission = 'LMS:Faq:Modify';
        export const insertPermission = 'LMS:Faq:Modify';
        export const readPermission = 'LMS:Faq:Read';
        export const updatePermission = 'LMS:Faq:Modify';

        export declare const enum Fields {
            Id = "Id",
            Question = "Question",
            Answer = "Answer",
            EntityType = "EntityType",
            EntityId = "EntityId",
            DisplayOrder = "DisplayOrder",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate",
            IsActive = "IsActive",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
